import { Mutation, Action } from 'vuex';
import { StoreModuleType } from "@/utils/store";
import { ResponseData } from '@/utils/request';
import {
    dailynewArticles,
    weeknewWorks,
    monthnewTopics,
    annualnewLinks,
    hotSearchQueryList,
    hotTagsQueryList,
    articleHitQueryList,
    worksHitQueryList,
    getOrderNumber,
    getTimeliness,
    getPageList,
    productExplainList,
    pickupScopeInfo,
    selfDeliveryScopeInfo,
    noticeInfo,
  } from './service';
import {
    ArticleChartDataType,
    WorksChartDataType,
    TopicsChartDataType,
    LinksChartDataType,
    HotSearchDataType,
    HotTagsDataType,
    ArticleHitDataType,
    WorksHitDataType,
    TableListQueryParams,
    UserInfoType,
    userOrderDataType,
    orderType,
    TableDataType,
    getTableList,
    productExplainType,
    noticeInfoType,
    noticeDataType,
    selfOrPostSearchType
  } from './data';

export interface StateType {
  articleChartData: ArticleChartDataType;
  worksChartData: WorksChartDataType;
  topicsChartData: TopicsChartDataType;
  linksChartData: LinksChartDataType;
  hotSearchData: HotSearchDataType;
  hotTagsData: HotTagsDataType;
  articleHitData: ArticleHitDataType;
  worksHitData: WorksHitDataType;
  userOrderInfo: userOrderDataType;
  timelinessList: any;
  tableData: TableDataType;
  errorMsg?: string;
  explainDataInfo: any[];
  pickupList: any[];
  selfDeliveryList: any[];
  notice:  noticeDataType;
}

export interface ModuleType extends StoreModuleType<StateType> {
    state: StateType;
    mutations: {
        changeErrorMsg: Mutation<StateType>;
        setArticleChartData: Mutation<StateType>;
        setWorksChartData: Mutation<StateType>;
        setTopicsChartData: Mutation<StateType>;
        setLinksChartData: Mutation<StateType>;
        setHotSearchData: Mutation<StateType>;
        setHotTagsData: Mutation<StateType>;
        setArticleHitData: Mutation<StateType>;
        setWorksHitData: Mutation<StateType>;
        userOrderDataList: Mutation<StateType>;
        timelinessViewData: Mutation<StateType>;
        getPageListData: Mutation<StateType>;
        explainData: Mutation<StateType>;
        pickupScope: Mutation<StateType>;
        selfDelivery: Mutation<StateType>;
        noticeInfoData: Mutation<StateType>;
        
    };
    actions: {
        queryArticleChartData: Action<StateType, StateType>;
        queryWorksChartData: Action<StateType, StateType>;
        queryTopicsChartData: Action<StateType, StateType>;
        queryLinksChartData: Action<StateType, StateType>;
        queryHotSearchData: Action<StateType, StateType>;
        queryHotTagsData: Action<StateType, StateType>;
        queryArticleHitData: Action<StateType, StateType>;
        queryWorksHitData: Action<StateType, StateType>;
        getOrderNumberData: Action<StateType, StateType>;
        getTimelinessData: Action<StateType, StateType>;
        getPageListFn: Action<StateType, StateType>;
        explainListFn: Action<StateType, StateType>;
        pickupScopeFn: Action<StateType, StateType>;
        selfDeliveryScopeFn: Action<StateType, StateType>;
        getNoticeInfoFn: Action<StateType, StateType>;
    };
}

const initState: StateType = {
    errorMsg: undefined,
    articleChartData: {
      total: 0,
      num: 0,
      week: 0,
      day: 0,
    },
    worksChartData: {
      total: 0,
      num: 0,
      chart: {
        day: [],
        num: [],
      },
    },
    topicsChartData: {
      total: 0,
      num: 0,
      chart: {
        day: [],
        num: [],
      },
    },
    linksChartData: {
      total: 0,
      num: 0,
      chart: {
        day: [],
        num: [],
      },
    },
    hotSearchData: {
        list: [],
        pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
        showSizeChanger: false,
        },
    },
    hotTagsData: {
        list: [],
        pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
        showSizeChanger: false,
        },
    },
    articleHitData: {
        list: [],
        pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
        showSizeChanger: false,
        },
    },
    worksHitData: {
        list: [],
        pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
        showSizeChanger: false,
        },
    },
    userOrderInfo: {
        toShipQty: 0,
        pickedQty: 0,
        abnormalQty: 0
    },
    timelinessList:{},
    tableData: {
        contlist: [],
        pagination: {
            total: 0,
            current: 0,
            pageNo: 1,
            pageSize: 10,
            sumDataCount: true,
            sumPageCount: true,
            showSizeChanger: true,
            showQuickJumper: true
        },
    },
    explainDataInfo:[],
    pickupList:[],
    selfDeliveryList:[],
    notice:{
        userCode: '',
        userType: 0,
        accountType: 0,
        creditAvailable: 0,
        creditBill: 0,
        accountStatus: 0,
        cashAvailable: 0,
        authenticationStatus: 0,
        signStatus: 0
    }
};

const StoreModel: ModuleType = {
    namespaced: true,
    name: 'Home',
    state: {
        ...initState
    },
    mutations: {
        changeErrorMsg(state, payload) {
            state.errorMsg = payload;
        },
        setArticleChartData(state, payload) {
            state.articleChartData = payload;
        },
        setWorksChartData(state, payload) {
            state.worksChartData = payload;
        },
        setTopicsChartData(state, payload) {
            state.topicsChartData = payload;
        },
        setLinksChartData(state, payload) {
            state.linksChartData = payload;
        },
        setHotSearchData(state, payload) {
            state.hotSearchData = payload;
        },
        setHotTagsData(state, payload) {
            state.hotTagsData = payload;
        },
        setArticleHitData(state, payload) {
            state.articleHitData = payload;
        },
        setWorksHitData(state, payload) {
            state.worksHitData = payload;
        },
        userOrderDataList(state, payload) {
            state.userOrderInfo = payload;
        },
        timelinessViewData(state, payload) {
            state.timelinessList = payload;
        },
        getPageListData(state, payload) {
            state.tableData = payload;
        },
        explainData(state, payload) {
            state.explainDataInfo = payload;
        },
        pickupScope(state, payload) {
            state.pickupList = payload;
        },
        selfDelivery(state, payload) {
            state.selfDeliveryList = payload;
        },
        noticeInfoData(state, payload) {
            state.notice = payload;
        },
    },
    actions: {
        async queryArticleChartData({ commit }) {
            try {
                const response: ResponseData = await dailynewArticles();
                const { data } = response;
                commit('setArticleChartData', {
                    ...initState.articleChartData,
                    ...data,
                });
                return true;
            } catch (error) {
                return false;
            }
        },
        async queryWorksChartData({ commit }) {
            try {
                const response: ResponseData = await weeknewWorks();
                const { data } = response;
                commit('setWorksChartData', {
                    ...initState.worksChartData,
                    ...data,
                });
                return true;
            } catch (error) {
                return false;
            }
        },
        async queryTopicsChartData({ commit }) {
            try {
                const response: ResponseData = await monthnewTopics();
                const { data } = response;
                commit('setTopicsChartData', {
                    ...initState.topicsChartData,
                    ...data,
                });
                return true;
            } catch (error) {
                return false;
            }
        },
        async queryLinksChartData({ commit }) {
            try {
                const response: ResponseData = await annualnewLinks();
                const { data } = response;
                commit('setLinksChartData', {
                    ...initState.linksChartData,
                    ...data,
                });
                return true;
            } catch (error) {
                return false;
            }
        },
        async queryHotSearchData({ commit }, payload: TableListQueryParams) {
            try {       
                const response: ResponseData = await hotSearchQueryList(payload);
                const { data } = response;
                commit('setHotSearchData',{
                    ...initState.hotSearchData,
                    list: data.list || [],
                    pagination: {
                        ...initState.hotSearchData.pagination,
                        current: payload.page,
                        total: data.total || 0,
                    },
                })        
                return true;
            } catch (error) {
                return false;
            }
        },
        async queryHotTagsData({ commit }, payload: TableListQueryParams) {
            try {    
                const response: ResponseData = await hotTagsQueryList(payload);
                const { data } = response;
                commit('setHotTagsData',{
                    ...initState.hotTagsData,
                    list: data.list || [],
                    pagination: {
                        ...initState.hotTagsData.pagination,
                        current: payload.page,
                        total: data.total || 0,
                    },
                })        
                return true;
            } catch (error) {
                return false;
            }
        },
        async queryArticleHitData({ commit }, payload: TableListQueryParams) {
            try {   
                const response: ResponseData = await articleHitQueryList(payload);
                const { data } = response;
                commit('setArticleHitData',{
                    ...initState.articleHitData,
                    list: data.list || [],
                    pagination: {
                        ...initState.articleHitData.pagination,
                        current: payload.page,
                        total: data.total || 0,
                    },
                })        
                return true;
            } catch (error) {
                return false;
            }
        },
        async queryWorksHitData({ commit }, payload: TableListQueryParams) {
            try {    
                const response: ResponseData = await worksHitQueryList(payload);
                const { data } = response;
                commit('setWorksHitData',{
                    ...initState.worksHitData,
                    list: data.list || [],
                    pagination: {
                        ...initState.worksHitData.pagination,
                        current: payload.page,
                        total: data.total || 0,
                    },
                })        
                return true;
            } catch (error) {
                return false;
            }
        },
        // 首页单量接口
        async getOrderNumberData({commit}, params:UserInfoType){
            try {
                const req: any = await getOrderNumber(params)
                const { body } = req
                commit('userOrderDataList', body)
                return true;
            } catch (error) {
                return false;
            }
        },
        // 时效展示
        async getTimelinessData({commit}, params:orderType){
            try {
                const req: any = await getTimeliness(params)
                const { body } = req
                commit('timelinessViewData', body)
                return true;
            } catch (error) {
                return false;
            }
        },
        // 苍鸾跨境专线产品 
        async getPageListFn({commit}, params:getTableList){
            let msg: string | undefined = undefined
            try{
                const req: ResponseData = await getPageList(params)
                const { body } = req
                const data = body?.datas
                commit('getPageListData', {
                    ...initState.tableData,
                    contlist: data || [],
                    pagination: {
                        ...initState.tableData.pagination,
                        current: params.pageNo,
                        pageNo: params.pageNo,
                        pageSize: params.pageSize,
                        total: body.sumDataCount || 0,
                        // showTotal: (total) => {
                        //     return " 共" + total + "条"
                        // }
                    }
                })
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
        async explainListFn({commit}, params:productExplainType){
            let msg: string | undefined = undefined
            try{
                const response:ResponseData = await productExplainList(params)
                const {body} = response
                // console.log(body)
                commit('explainData',body)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },

        async pickupScopeFn({commit}){
            let msg: string | undefined = undefined
            try{
                const response:ResponseData = await pickupScopeInfo()
                const {body} = response
                // const data = body?.datas
                commit('pickupScope',body)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
        
        async selfDeliveryScopeFn({commit}, params:selfOrPostSearchType){
            let msg: string | undefined = undefined
            try{
                const response:ResponseData = await selfDeliveryScopeInfo(params)
                const {body} = response
                // const data = body?.datas
                commit('selfDelivery',body)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
        async getNoticeInfoFn({commit}, params:noticeInfoType){
            let msg: string | undefined = undefined
            try{
                const response:ResponseData = await noticeInfo(params)
                const {body} = response
                commit('noticeInfoData',body)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        }
    }
}

export default StoreModel;
